// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1twK-","load1":"Spinner_load1__1BXDX"};